<template>
  <el-dialog
      title="错词反馈"
      :visible.sync="dialogVisible"
      width="400px"
      :before-close="handleClose"
  >
    <div class="opinion">
      <div class="main_box">
        <p class="title">错词反馈</p>
        <div class="form">
          <el-form ref="form" label-width="60px">
            <el-form-item label="星级：">
              <el-rate v-model="star" disabled></el-rate>
            </el-form-item>
            <el-form-item class="box" label="内容：">
              <el-input type="textarea" maxlength="255" id="input-area" placeholder="欢迎您提出宝贵的意见" v-model="opinion"></el-input>
              <span class="tips">{{ opinion.length + '/' }}255字</span>
            </el-form-item>
          </el-form>
        </div>


        <div slot="footer" class="dialog-footer">
          <el-button @click="submit">提 交</el-button>
          <el-button type="primary" @click="clear">清 空</el-button>
        </div>

      </div>
    </div>
  </el-dialog>
</template>
<script>
import { addFeedback } from '@/api/student'
export default {
  data() {
    return {
      dialogVisible: false,
      star: 5,
      opinion: '',
    };
  },
  methods: {
    handleClose() {
      this.dialogVisible = false
    },

    // 清空内容
    clear() {
      this.star = 5
      this.opinion = ''
    },
    // 提交内容
    submit() {
      if (!this.opinion || this.opinion.length > 255) {
        this.$message.warning('请填写255个字以内的意见')
        return false
      }
      this.$confirm('请核对提交信息，是否确认？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        addFeedback({ xgr: this.$store.state.userInfo.yhid, cjr: this.$store.state.userInfo.yhid, fkyj: this.opinion, xsid: this.$store.state.userInfo.yhid, xtpj: this.star, zhid: this.$store.state.userInfo.zhid, xsmc: this.$store.state.userInfo.realname, yycdid: this.$store.state.yycdid }).then(res => {
          if (res.success) {
            this.clear()
            this.$message.success('提交成功')
            this.dialogVisible = false
          } else {
            this.$message.error(res.resultDesc)
          }
        })
      }).catch(() => {
      })
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog{
  position: absolute;
  bottom: -50px;
  right: 0;
  border-top-left-radius: 6%;
  border-top-right-radius: 6%;

}
.dialog-content {
  text-align: center;
  margin-left: -30px;
}

.dialog-footer {
  padding: 10px;
  text-align: right;
  border-radius: 10px;
}

::v-deep .el-dialog__footer {
  padding: 0;
}


.opinion{
  .main_box{
    width: 100%;
    height: 100%;
    box-shadow: 0px 0px 16px 0px rgba(89, 144, 255, 0.3);
    border-radius: 10px;
    box-sizing: border-box;
    position: relative;
    padding-right: 4%;
    .title{
      width: 100%;
      height: 3vw;
      color: #333;
      font-weight: bold;
      font-size: 1.3vw;
      line-height: 3vw;
      text-align: center;
    }
    .footerBtn{
      width: 100%;
      height: calc(100% - 22vw);
      position: relative;
      div{
        display: inline-block;
        margin: auto;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        span{
          display: block;
          float: left;
          width: 7vw;
          height: 2.5vw;
          border-radius: 32px;
          text-align: center;
          line-height: 2.5vw;
          font-size: 1.1vw;
          cursor: pointer;
        }
        span:nth-child(1){
          background: #5990FF;
          color: #fff;
          margin-right: 2vw;
        }
        span:nth-child(2){
          background: #D9E6FF;
          color: #333;
        }
      }
    }
  }
  .box{
    position: relative;
    .tips{
      position: absolute;
      bottom: 0;
      right: 2vw;
    }
  }
}
/* ========== 手机端适配样式 ========== */
@media screen and (max-width: 768px) {
  ::v-deep .el-dialog {
    width: 90% !important;
    max-width: 350px;
    bottom: -20px;
    right: 5%;
    left: auto;
    margin: 0;
  }

  .opinion {
    .main_box {
      padding-right: 5%;

      .title {
        height: 40px;
        font-size: 16px;
        line-height: 40px;
      }

      .footerBtn {
        div {
          span {
            width: 80px;
            height: 32px;
            line-height: 32px;
            font-size: 14px;
          }
        }
      }
    }

    .box {
      .tips {
        font-size: 12px;
        right: 10px;
      }
    }
  }
}
</style>
<style lang="scss">
.opinion{
  .el-rate__item{
    font-size: 30px;
  }
  .el-form-item{
  }
  .el-textarea{
    height: 15vw;
    .el-textarea__inner{
      height: 100%;
    }
  }
  .el-textarea__inner{
    height: 15vw;
    background: #F9F9F9;
  }
  #input-area::-webkit-input-placeholder{
    color: #999999;
    font-size: 1.2vw;
    text-align: center;
    line-height: 12vw;
  }
}
@media screen and (max-width: 768px) {
  .opinion {
    .el-rate__item {
      font-size: 20px;
    }

    .el-textarea {
      height: 120px;

      .el-textarea__inner {
        height: 100%;
        font-size: 14px;
      }
    }

    #input-area::-webkit-input-placeholder {
      font-size: 14px;
      line-height: 100px;
    }
  }
}
</style>
